import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const UlIcon = (props) => {
  return (
   /* <svg
    className= {props.selected ? "svgEditorSelected": "svgEditor"}
    height="20"    
    width="20">  
    <rect x="3" y="4" width="2" height="1" rx="0"/> 
    <rect x="6" y="4" width="8" height="1" rx="0"/>  
    <rect x="3" y="7" width="2" height="1" rx="0"/>      
    <rect x="6" y="7" width="8" height="1" rx="0"/>  
    <rect x="3" y="10" width="2" height="1" rx="0"/>    
    <rect x="6" y="10" width="8" height="1" rx="0"/> 
    <rect x="3" y="13" width="2" height="1" rx="0"/>       
    <rect x="6" y="13" width="8" height="1" rx="0"/>    
  </svg>
*/
  
  <svg className= {props.selected ? "svgEditorSelected": "svgEditor"} version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="9.000000pt" height="9.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
 stroke="none">
<path d="M359 4629 c-124 -13 -254 -106 -313 -222 -114 -227 6 -508 250 -582
27 -8 81 -15 119 -15 118 0 209 37 290 118 280 280 50 745 -346 701z"/>
<path d="M1250 4220 l0 -280 1935 0 1935 0 0 280 0 280 -1935 0 -1935 0 0
-280z"/>
<path d="M295 2956 c-70 -22 -119 -52 -170 -104 -203 -203 -144 -542 115 -666
61 -29 73 -31 175 -31 102 0 115 2 176 31 166 79 261 260 231 440 -22 134
-110 250 -231 308 -58 27 -78 31 -161 33 -58 2 -111 -3 -135 -11z"/>
<path d="M1250 2560 l0 -280 1935 0 1935 0 0 280 0 280 -1935 0 -1935 0 0
-280z"/>
<path d="M293 1296 c-194 -63 -318 -263 -285 -460 55 -331 463 -465 697 -228
202 204 144 543 -115 666 -56 26 -78 31 -160 33 -60 2 -110 -2 -137 -11z"/>
<path d="M1250 900 l0 -280 1935 0 1935 0 0 280 0 280 -1935 0 -1935 0 0 -280z"/>
</g>
</svg>
  );
};

export default UlIcon;
